// extracted by mini-css-extract-plugin
module.exports = {"mediumCard":"ProcessingAsset_mediumCard__IGOP3","cardCenter":"ProcessingAsset_cardCenter__aoZze","text":"ProcessingAsset_text__xO37Q"};